import { CommonKeyMapping } from 'models/platforms/commonKeyMappings';
import { OneTrustRemoteKeys } from 'types/oneTrust';

const MandatoryLGKeyMapping = {
  37: 'Left',
  38: 'Up',
  39: 'Right',
  40: 'Down',
  13: 'Enter',
  461: 'Back',
};

export const AdditionalLGKeyMapping = {
  ...CommonKeyMapping,
} as const;

export const LGKeyMapping: Record<number, string> = {
  ...MandatoryLGKeyMapping,
  ...AdditionalLGKeyMapping,
};

/**
 * Back keys handed to OneTrust. Chromium leaves `event.code` empty for the
 * vendor code 461, so OneTrust falls through to the `keyCode`.
 */
export const LGOneTrustKeyMapping: OneTrustRemoteKeys = {
  461: 'BACK',
};
